var _path, _path2, _path3, _path4, _path5, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.99 2.674c-2.183-1.13-2.648 1.66-2.733 3.49-.038.804 0 1.417 0 1.417V21.12c0 .76-.28 1.512-.899 1.946-.584.41-1.322.806-2.17.806-1.694 0-3.069-1.232-3.069-2.752V2.753c0-.76.344-1.449.899-1.947A3.247 3.247 0 0 1 3.188 0c.575 0 1.114.142 1.573.39l.018.009 4.21 2.275z",
    fill: "url(#y6yodkdkma)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.319 14.722 4.54 23.652A3.3 3.3 0 0 1 3.055 24c-1.07 0-2.11-.508-2.667-1.408a2.51 2.51 0 0 1-.386-1.418H0l.128-4.404c-.036 2.255 2.925 1.252 4.737.429.741-.337 1.29-.643 1.364-.684l.006-.003.002-.002 13.105-6.582c.471-.237.982-.348 1.485-.348 1.07 0 2.11.507 2.668 1.407.821 1.324.295 2.996-1.177 3.735z",
    fill: "url(#aky45bki7b)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.23 16.515c-.074.04-.623.347-1.364.684l1.363-.684z",
    fill: "url(#txvuuyphoc)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.085 16.831c2.19-1.096-.253-2.905-1.95-3.907-.746-.441-1.347-.726-1.347-.726L1.908 5.263c-.723-.39-1.294-.99-1.392-1.687-.092-.659-.09-1.428.342-2.079.866-1.3 2.74-1.723 4.187-.945l17.47 9.408c.724.39 1.203 1.005 1.393 1.687a2.5 2.5 0 0 1-.342 2.078 2.924 2.924 0 0 1-1.174 1.009.35.35 0 0 0-.018.008l-4.289 2.09z",
    fill: "url(#6u6wtja3od)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.991 2.674c-2.182-1.13-2.649 1.66-2.734 3.49-.038.804 0 1.417 0 1.417V21.12c0 .76-.28 1.512-.898 1.946-.585.41-1.323.806-2.17.806-1.695 0-3.07-1.232-3.07-2.752V2.753c0-.76.344-1.449.9-1.947A3.247 3.247 0 0 1 3.188 0c.575 0 1.113.142 1.573.39l.017.009 4.212 2.275z",
    fill: "url(#dhm4e3io1e)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "y6yodkdkma",
    x1: 12.001,
    y1: 0,
    x2: 12.001,
    y2: 24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#577DF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#5276EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#4664D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#3347A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#181F65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#06043A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aky45bki7b",
    x1: 0,
    y1: 11.999,
    x2: 24,
    y2: 11.999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#577DF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#5276EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#4664D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#3347A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#181F65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#06043A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "txvuuyphoc",
    x1: 0,
    y1: 12,
    x2: 24,
    y2: 12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#39B54A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#577DF7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "6u6wtja3od",
    x1: 22.849,
    y1: 21.051,
    x2: -2.889,
    y2: 8.915,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#577DF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#5276EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#4664D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#3347A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#181F65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#06043A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dhm4e3io1e",
    x1: 0.12,
    y1: 11.936,
    x2: 8.991,
    y2: 11.936,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#577DF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#5276EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#4664D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#3347A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#181F65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#06043A"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.b530e3dcac3c9686b160644cc1ade3d5.svg";
export { ForwardRef as ReactComponent };